import { Canvas } from "@react-three/fiber";
import { Suspense, useState } from "react";

// import clamMusic from "../assets/sakura.mp3";
import { HomeInfo, Loader } from "../components";
import { hand } from "../assets/icons";
import { Island, Plane, Sky, Birds } from "../models";

const Home = () => {
  // const audioRef = useRef(new Audio(clamMusic));
  // audioRef.current.volume = 0.4;
  // audioRef.current.loop = true;

  const [currentStage, setCurrentStage] = useState(1);
  const [isRotating, setIsRotating] = useState(false);
  // const [isPlayingMusic, setIsPlayingMusic] = useState(false);

  // useEffect(() => {
  //   let audioRefCurrent = audioRef.current;
  //   if (isPlayingMusic) {
  //     audioRefCurrent.play();
  //   }

  //   return () => {
  //     audioRefCurrent.pause();
  //   };
  // }, [isPlayingMusic]);

  const adjustBiplaneForScreenSize = () => {
    let screenScale, screenPosition;

    // If screen width is less than 768px, adjust the scale and position
    if (window.innerWidth < 768) {
      screenScale = [1.5, 1.5, 1.5];
      screenPosition = [0, -1.5, 0];
    } else {
      screenScale = [3, 3, 3];
      screenPosition = [0, -4, -4];
    }

    return [screenScale, screenPosition];
  };

  const adjustIslandForScreenSize = () => {
    let screenScale, screenPosition;

    if (window.innerWidth < 768) {
      screenScale = [0.9, 0.9, 0.9];
      screenPosition = [0, -6.5, -43.4];
    } else {
      screenScale = [1, 1, 1];
      screenPosition = [0, -6.5, -43.4];
    }

    return [screenScale, screenPosition];
  };

  const [biplaneScale, biplanePosition] = adjustBiplaneForScreenSize();
  const [islandScale, islandPosition] = adjustIslandForScreenSize();

  return (
    <section className="w-full h-screen relative">
      <div className="absolute top-28 left-0 right-0 z-10 flex items-center justify-center">
        {currentStage && <HomeInfo currentStage={currentStage} />}
      </div>

      {!isRotating && ![2, 3, 4].includes(currentStage) && (
        <div className="absolute z-10 top-64 left-0 right-0 flex items-center justify-center">
          <img className="h-8 w-8  hand-icon" src={hand} alt="drag" />
        </div>
      )}

      <Canvas
        className={`w-full h-screen bg-transparent ${
          isRotating ? "cursor-grabbing" : "cursor-grab"
        }`}
        camera={{ near: 0.1, far: 1000 }}
      >
        <Suspense fallback={<Loader />}>
          <directionalLight
            position={[5, 1, 1]}
            intensity={0.3}
            castShadow // Enable shadow casting for the directional light
          />
          <ambientLight intensity={1.2} />
          <pointLight position={[5, 5, 10]} intensity={6} />
          <spotLight
            position={[0, 50, 10]}
            angle={0.15}
            penumbra={1}
            intensity={4}
            castShadow // Enable shadow casting for the spot light
          />
          <hemisphereLight
            skyColor="#b1e1ff"
            groundColor="#000000"
            intensity={0.5}
          />

          <Birds />
          <Sky isRotating={isRotating} />
          <Island
            isRotating={isRotating}
            setIsRotating={setIsRotating}
            setCurrentStage={setCurrentStage}
            position={islandPosition}
            rotation={[0.1, 4.7077, 0]}
            scale={islandScale}
            receiveShadow // Enable shadow receiving for the island object
          />
          <Plane
            isRotating={isRotating}
            position={biplanePosition}
            rotation={[0, 20.1, 0]}
            scale={biplaneScale}
            castShadow // Enable shadow casting for the plane object
          />
        </Suspense>
      </Canvas>

      {/* <div className="absolute bottom-16 left-4 z-10">
        <img
          src={!isPlayingMusic ? soundoff : soundon}
          alt="jukebox"
          onClick={() => setIsPlayingMusic(!isPlayingMusic)}
          className="w-10 h-10 cursor-pointer object-contain"
        />
      </div> */}
    </section>
  );
};

export default Home;
